import React from "react";
import "./InsightStory.css";
const d3 = require("d3");

import PathToCoordinates from "../../../AxiomComponents/PathToCoordinates/PathToCoordinates.js";
import * as AxiomFormula from "../../../AxiomComponents/AxiomGrid/component/reference/plugins/commonJS/AxiomFormula.js";

const getChildComponent = require("./InsightStoryChildComponent.js");
export default class InsightStory extends React.Component {
  constructor(props) {
    super(props);
    this.state = $.extend(
      true,
      {
        componentName: "InsightStory",
        radius: 3.5,
        filteredDotRadius: 20,
        dotColor: "rgb(216, 125, 103)",
        splitBar: {
          leftMargin: 150,
          topMargin: 100,
          labelWidth: 200,
          labelHeight: 30,
          barGap: 30,
          numDotsInRow: 21,
        },
        discardDelay: 200,
        discardDuration: 500,
        delay: 200,
        duration: 500,
        isSearchFocused: false,
        // colorPalette1:["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab"],
        // colorPalette2: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5","#ffed6f"],
        multiColor: false,
        zoomValue: null,
      },
      props
    );
    this.searchRef = React.createRef();
    AxiomAPIs.registerStateChange(this.props.appName, this.props.appID, this);
  }

  dispatchEvent = (eventType, eventName, eventData) => {
    var component = this;
    // setTimeout for 0ms will make the code inside it asyncronus
    setTimeout(() => {
      let event = new CustomEvent(eventType, {
        detail: {
          appName: component.props.appName,
          appID: component.props.appID,
          componentID: component.props.componentID,
          componentName: component.state.componentName,
          eventName: eventName,
          data: eventData,
        },
      });
      AxiomAPIs.dispatchEvent(event);
    }, 0);
  };

  componentDidCatch(error) {
    console.error(error);
  }

  componentDidMount() {
    this.renderComponent();
    d3.select(this.searchRef.current).on("keydown", () => {
      if (d3.event.keyCode == 13) {
        const searchQuery = this.searchRef.current.value;
        // To-Do: Perform search based on value;
        this.dispatchEvent("AxiomEventInfo", "setSearchBarFocus", {
          isSearchFocused: false,
        });
        this.searchRef.current.blur();
      }
      d3.event.stopPropagation();
    });
    d3.select(this.searchRef.current).on("blur", () => {
      if (!this.searchRef.current.value) {
        this.dispatchEvent("AxiomEventInfo", "setSearchBarFocus", {
          isSearchFocused: false,
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.circleData != this.state.circleData) {
      this.prepareData();
    } else if (prevState.step != this.state.step || prevState.focusValue != this.state.focusValue) {
      this.executeStep();
    }
  }

  prepareData() {
    if (this.state.focusValue != null) {
      this.dispatchEvent("AxiomEventInfo", "changeFocusItem", { focusValue: null });
    }
    this.oddEven = true;
    this.dotsData = this.props.circleData.map((d) => {
      return $.extend(true, {}, d);
    });
    const missingDots = this.props.minCircles - this.dotsData.length;
    if (missingDots > 0) {
      for (let i = 0; i < missingDots; i++) {
        this.dotsData.push({ data: null });
      }
    }
    this.dotsData = d3.shuffle(this.dotsData);
    this.executeStep();
  }

  executeStep() {
    this.oddEven = !this.oddEven;
    this.applyFilter();
    const step = this.state.step;
    if (step.operation === "arrange") {
      if (step.type === "svg") {
        this.placeSVG();
      } else if (step.type === "splitBar") {
        // this.splitBar();
        this.splitColumn();
      } else if (step.type === "singleVerticleLine") {
        this.singleVerticleLine();
      } else if (step.type === "splitBarCompare") {
        this.splitBarCompare();
      } else if (step.type === "scatterPlot") {
        this.scatterPlot();
      } else if (step.type === "scatterPlotPlanVsForecastError") {
        this.scatterPlotPlanVsForecastError();
      } else if (step.type === "listWithinCircularGroup") {
        this.listWithinCircularGroup();
      } else {
        console.log(`Unknown type "${step.type}" found for operation "${step.operation}"`);
      }
    } else if (step.operation === "focus") {
      this.zoomDot();
    } else {
      console.log(`Unknown operation "${step.operation}" found`);
    }
    this.renderUpdates();
  }

  placeSVG() {
    const paths = $(this.state.step.svgData).find("path");
    let zoomWidth = 1,
      zoomHeight = 1;
    const maxLogoWidth = this.props.width - 40;
    const maxLogoHeight = this.props.height - 10;

    zoomWidth = maxLogoWidth / this.state.step.width;
    zoomHeight = maxLogoHeight / this.state.step.height;

    const finalZoom = d3.min([zoomWidth, zoomHeight]);

    const actualLogoWidth = this.state.step.width * finalZoom;
    const actualLogoHeight = this.state.step.height * finalZoom;
    let points = null;
    if (!this.points) {
      points = PathToCoordinates(
        paths,
        finalZoom,
        this.dotsData.length,
        (this.props.width - actualLogoWidth) / 2,
        (this.props.height - actualLogoHeight) / 2,
        false
      );
      this.points = points;
    } else {
      points = this.points;
    }
    this.dotsData.forEach((d, i) => {
      d.cx = points[i][0];
      d.cy = points[i][1];
      d.r = this.dotsRadius;
      d.color = this.state.dotColor;
      delete d.discard;
    });
  }

  applyFilter() {
    this.svgHeight = this.props.height - 40;
    this.dotsRadius = this.state.radius;
    this.svgWidth = this.props.width;
    this.rectData = [];
    this.labelData = [];
    this.pathData = [];
    const step = this.state.step;
    let filterFormula = step.filterExpression;
    if (filterFormula) {
      filterFormula = AxiomFormula.evaluateAxiomFormula({
        formula: filterFormula,
        getSplitValues: true,
      });
    }
    let highlightFormula = step.highlightExpression;
    if (highlightFormula) {
      highlightFormula = AxiomFormula.evaluateAxiomFormula({
        formula: highlightFormula,
        getSplitValues: true,
      });
    }
    this.dotsData.forEach((d) => {
      if (!d.data) {
        d.isHighlighted = false;
      } else if (highlightFormula) {
        const formulaVariables = [];
        highlightFormula.formulaVariables.forEach((f) => {
          formulaVariables.push(d.data[f]);
        });
        const condition = AxiomFormula.evaluateAxiomFormula({
          formulaTree: highlightFormula.formulaTree,
          rangeKeys: [],
          rangeValues: {},
          variableKeys: highlightFormula.formulaVariables,
          variableValues: formulaVariables,
        });
        if (!condition) {
          d.isHighlighted = false;
        } else {
          d.isHighlighted = true;
        }
      } else {
        d.isHighlighted = true;
      }

      d.prevDiscard = d.discard;
      if (!d.data) {
        d.discard = true;
        return;
      }
      if (filterFormula) {
        const formulaVariables = [];
        filterFormula.formulaVariables.forEach((f) => {
          formulaVariables.push(d.data[f]);
        });
        const condition = AxiomFormula.evaluateAxiomFormula({
          formulaTree: filterFormula.formulaTree,
          rangeKeys: [],
          rangeValues: {},
          variableKeys: filterFormula.formulaVariables,
          variableValues: formulaVariables,
        });
        if (!condition) {
          d.discard = true;
          return;
        }
      }
      delete d.discard;
    });
  }

  splitBar() {
    const _this = this;
    const step = this.state.step;

    let buckets = null;
    if (step.bucketInfo) {
      buckets = step.bucketInfo;
    } else {
      const minMax = d3.extent(_this.dotsData.filter((d) => d.data).map((d) => d.data[step.field]));
      buckets = d3.ticks(minMax[0], minMax[1], 5);
      if (buckets[0] === minMax[0]) {
        buckets.shift();
      }
      if (buckets[buckets.length - 1] === minMax[1]) {
        buckets.pop();
      }
      buckets.push(Infinity);
      buckets = buckets.map((d, i) => {
        return {
          rank: i,
          start: i === 0 ? -Infinity : buckets[i - 1],
          end: i === buckets.length - 1 ? Infinity : buckets[i],
          text:
            i === 0
              ? `<${d}`
              : i === buckets.length - 1
              ? `>=${buckets[i - 1]}`
              : `${buckets[i - 1]} - ${d}`,
        };
      });
    }

    buckets = buckets.sort((a, b) => {
      return a.rank - b.rank;
    });

    buckets.forEach((d) => (d.dots = []));

    this.dotsData
      .filter((f) => f.data && !f.discard)
      .forEach((d) => {
        buckets.some((b) => {
          if (
            d.data[step.field] < (b.end == null ? Infinity : b.end) &&
            d.data[step.field] >= (b.start == null ? -Infinity : b.start)
          ) {
            b.dots.push(d);
            return true;
          }
          return false;
        });
      });

    const { leftMargin, topMargin, labelWidth, numDotsInRow, barGap } =
      step.splitBar || _this.state.splitBar;
    const actualWidthForBucket = this.props.width - (buckets.length + 1) * barGap;
    let radiusForSingleDots = actualWidthForBucket / (numDotsInRow * buckets.length * 2);
    radiusForSingleDots =
      radiusForSingleDots > this.state.radius ? this.state.radius : radiusForSingleDots;
    this.dotsRadius = radiusForSingleDots;
    buckets.forEach((bucket, bIndex) => {
      this.labelData.push({
        class: "buckets title-text-size",
        text: bucket.text,
        dx: leftMargin,
        dy:
          topMargin +
          bIndex * (numDotsInRow * radiusForSingleDots * 2 + barGap) +
          (numDotsInRow * radiusForSingleDots * 2) / 2,
      });
      this.labelData.push({
        class: "count title-text-size",
        text: `(${bucket.dots.length})`,
        dx:
          leftMargin +
          labelWidth +
          (bucket.dots.length > 0 ? Math.ceil((bucket.dots.length - 1) / numDotsInRow) : 0) *
            radiusForSingleDots *
            2 +
          10,
        dy:
          topMargin +
          bIndex * (numDotsInRow * radiusForSingleDots * 2 + barGap) +
          (numDotsInRow * radiusForSingleDots * 2) / 2,
      });

      bucket.dots.forEach((dot, dIndex) => {
        dot.cx =
          leftMargin +
          labelWidth +
          Math.ceil((dIndex + 1) / numDotsInRow) * radiusForSingleDots * 2;
        dot.cy =
          topMargin +
          bIndex * (numDotsInRow * radiusForSingleDots * 2 + barGap) +
          (dIndex % numDotsInRow) * radiusForSingleDots * 2;
        dot.r = radiusForSingleDots;
        if (this.state.multiColor) {
          if (this.oddEven) {
            dot.color = this.state.colorPalette1[dIndex % this.state.colorPalette1.length];
          } else {
            dot.color = this.state.colorPalette2[dIndex % this.state.colorPalette2.length];
          }
        } else {
          dot.color = this.state.dotColor;
        }
      });
    });

    // this.labelData = buckets;
  }

  splitColumn() {
    const _this = this;
    const step = this.state.step;

    let buckets = null;
    if (step.bucketInfo) {
      buckets = step.bucketInfo;
    } else {
      const minMax = d3.extent(_this.dotsData.filter((d) => d.data).map((d) => d.data[step.field]));
      buckets = d3.ticks(minMax[0], minMax[1], 4);
      if (buckets[0] === minMax[0]) {
        buckets.shift();
      }
      if (buckets[buckets.length - 1] === minMax[1]) {
        buckets.pop();
      }
      buckets.push(Infinity);
      buckets = buckets.map((d, i) => {
        return {
          rank: i,
          start: i === 0 ? -Infinity : buckets[i - 1],
          end: i === buckets.length - 1 ? Infinity : buckets[i],
          text:
            i === 0
              ? `<${d}`
              : i === buckets.length - 1
              ? `>=${buckets[i - 1]}`
              : `${buckets[i - 1]} - ${d}`,
        };
      });
    }

    buckets = buckets.sort((a, b) => {
      return a.rank - b.rank;
    });

    buckets.forEach((d) => (d.dots = []));

    this.dotsData
      .filter((f) => f.data && !f.discard)
      .forEach((d) => {
        buckets.some((b) => {
          if (
            d.data[step.field] < (b.end == null ? Infinity : b.end) &&
            d.data[step.field] >= (b.start == null ? -Infinity : b.start)
          ) {
            b.dots.push(d);
            return true;
          }
          return false;
        });
      });

    const { barGap, topMargin, numDotsInRow, labelHeight } = step.splitBar || _this.state.splitBar;
    const actualWidthForBucket = this.props.width - (buckets.length + 1) * barGap;
    let radiusForSingleDots = actualWidthForBucket / (numDotsInRow * buckets.length * 2);
    radiusForSingleDots =
      radiusForSingleDots > this.state.radius ? this.state.radius : radiusForSingleDots;
    this.dotsRadius = radiusForSingleDots;
    const rectWidthHeight = numDotsInRow * radiusForSingleDots * 2 + 2;
    let leftMargin =
      (this.props.width - (buckets.length * (rectWidthHeight + barGap) - barGap)) / 2;
    buckets.forEach((bucket, bIndex) => {
      this.rectData.push({
        x: leftMargin + bIndex * (rectWidthHeight + barGap) - radiusForSingleDots,
        y: topMargin + labelHeight - radiusForSingleDots,
        height: rectWidthHeight,
        width: rectWidthHeight,
      });
      this.labelData.push({
        class: "buckets centered title-text-size",
        text: bucket.text,
        dx: leftMargin + bIndex * (rectWidthHeight + barGap) + rectWidthHeight / 2,
        dy: topMargin,
      });
      // this.labelData.push({ class: "count", text: `(${bucket.dots.length})`, dx: leftMargin + labelWidth + (bucket.dots.length > 0 ? Math.ceil((bucket.dots.length - 1) / numDotsInRow) : 0) * radiusForSingleDots * 2 + 10, dy: topMargin + (bIndex * ((numDotsInRow * radiusForSingleDots * 2) + barGap)) + (numDotsInRow * radiusForSingleDots * 2) / 2 })
      bucket.dots.forEach((dot, dIndex) => {
        let bucketMiddlePos =
          leftMargin +
          bIndex * (rectWidthHeight + barGap) +
          rectWidthHeight / 2 -
          radiusForSingleDots;
        let dotIndexInRow = dIndex % numDotsInRow;
        dot.cx =
          bucketMiddlePos +
          (dotIndexInRow === 0
            ? 0
            : dotIndexInRow % 2 !== 0
            ? Math.ceil(dotIndexInRow / 2)
            : (-1 * dotIndexInRow) / 2) *
            radiusForSingleDots *
            2;
        dot.cy =
          topMargin +
          labelHeight +
          rectWidthHeight -
          Math.ceil((dIndex + 1) / numDotsInRow) * radiusForSingleDots * 2 -
          1;
        dot.r = radiusForSingleDots;
        if (this.state.multiColor) {
          if (this.oddEven) {
            dot.color = this.state.colorPalette1[bIndex % this.state.colorPalette1.length];
          } else {
            dot.color = this.state.colorPalette2[bIndex % this.state.colorPalette2.length];
          }
        } else {
          dot.color = this.state.dotColor;
        }
      });
    });

    // this.labelData = buckets;
  }

  splitBarCompare() {
    const _this = this;
    const step = this.state.step;
    this.prepareDataForSplitBar(
      step.left.splitBar,
      step.left.bucketInfo,
      step.left.field,
      step.left.displayType.toString(),
      step.left.highlightBucket,
      step.right.bucketInfo,
      step.right.field,
      step.right.displayType.toString(),
      1
    ); //step.left.bucketInfo
    this.prepareDataForSplitBar(
      step.right.splitBar,
      step.right.bucketInfo,
      step.right.field,
      step.right.displayType.toString(),
      step.right.highlightBucket,
      step.left.bucketInfo,
      step.left.field,
      step.left.displayType.toString(),
      2
    ); //step.left.bucketInfo
    this.svgHeight = step.left.splitBar.topMargin + step.left.bucketInfo.length * 75 + 50;
    if (this.svgHeight < this.props.height - 40) {
      this.svgHeight = this.props.height - 40;
    }
  }

  prepareDataForSplitBar(
    splitBar,
    bucketInfo,
    field,
    type,
    highlightBucket,
    otherBucket,
    otherBucketField,
    otherBucketType,
    side
  ) {
    //colorBucket
    const _this = this;
    let buckets = null;
    buckets = bucketInfo;

    buckets = buckets.sort((a, b) => {
      return a.rank - b.rank;
    });

    buckets.forEach((d) => (d.dots = []));
    otherBucket.forEach((d) => (d.dots = []));

    this.dotsData
      .filter((f) => f.data && !f.discard && type == f.data.type)
      .forEach((d) => {
        buckets.some((b) => {
          if (
            +d.data[field] < (b.end == null ? Infinity : b.end) &&
            +d.data[field] >= (b.start == null ? -Infinity : b.start)
          ) {
            b.dots.push(d);
            return true;
          }
          return false;
        });
      });

    this.dotsData
      .filter((f) => f.data && !f.discard && otherBucketType == f.data.type)
      .forEach((d) => {
        otherBucket.some((b) => {
          if (
            +d.data[otherBucketField] < (b.end == null ? Infinity : b.end) &&
            +d.data[otherBucketField] >= (b.start == null ? -Infinity : b.start)
          ) {
            b.dots.push(d);
            return true;
          }
          return false;
        });
      });

    let { topMargin, numDotsInRow } = splitBar;

    topMargin += 10;
    const barGap = 30;
    const barGapH = 75;
    const rectWidth = Math.ceil(50 * _this.dotsRadius * 2);
    const rectHeight = numDotsInRow * _this.dotsRadius * 2 + 4;

    this.labelData.push({
      class: "buckets centered title-text-size",
      text: field + " buckets",
      dx: this.props.width / 2 + (side === 1 ? -1 : 1) * (rectWidth / 2 + barGapH - 5),
      dy: topMargin - ((numDotsInRow * _this.dotsRadius * 2) / 2 + 10),
    });

    buckets.forEach((bucket, bIndex) => {
      bucket.dots = [
        ...bucket.dots.filter((d) => d.isHighlighted),
        ...bucket.dots.filter((d) => !d.isHighlighted),
      ];

      this.rectData.push({
        class: highlightBucket === bucket.text ? "highlight " : "",
        x: this.props.width / 2 + (side === 1 ? -1 * (rectWidth + barGapH) : barGapH),
        y:
          topMargin -
          (_this.dotsRadius + 2) +
          bIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap),
        width: rectWidth,
        height: rectHeight,
      });
      this.labelData.push({
        class:
          "title-text-size buckets " +
          (side === 2 ? "right " : "") +
          (highlightBucket === bucket.text ? "highlight " : ""),
        text: bucket.text,
        dx: this.props.width / 2 + (side === 1 ? -1 : 1) * (rectWidth + barGapH - 5),
        dy:
          topMargin +
          bIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
          (numDotsInRow * _this.dotsRadius * 2) / 2,
      });
      if (highlightBucket === bucket.text && side === 1) {
        otherBucket.forEach((oBucket, oIndex) => {
          if (
            oBucket.dots.some((s) =>
              bucket.dots
                .filter((f) => f.isHighlighted)
                .map((m) => m.key)
                .includes(s.key)
            )
          ) {
            const leftTopPoint = [
              this.props.width / 2 + (side === 1 ? -1 : 1) * barGapH + 5,
              topMargin -
                (_this.dotsRadius + 2) +
                bIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
                1,
            ];
            const leftBottomPoint = [leftTopPoint[0], leftTopPoint[1] + rectHeight - 2];
            const rightTopPoint = [
              this.props.width / 2 + (side === 1 ? 1 : -1) * barGapH - 5,
              topMargin -
                (_this.dotsRadius + 2) +
                oIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
                1,
            ];
            const rightBottomPoint = [rightTopPoint[0], rightTopPoint[1] + rectHeight - 2];
            this.pathData.push({
              d: `
                M${leftTopPoint[0]},${leftTopPoint[1]}
                C${leftTopPoint[0] + (rightTopPoint[0] - leftTopPoint[0]) / 2},${leftTopPoint[1]},${
                leftTopPoint[0] + (rightTopPoint[0] - leftTopPoint[0]) / 2
              },${rightTopPoint[1]},${rightTopPoint[0]},${rightTopPoint[1]}
                L${rightBottomPoint[0]},${rightBottomPoint[1]}
                C${rightBottomPoint[0] - (rightBottomPoint[0] - leftBottomPoint[0]) / 2},${
                rightBottomPoint[1]
              },${rightBottomPoint[0] - (rightBottomPoint[0] - leftBottomPoint[0]) / 2},${
                leftBottomPoint[1]
              },${leftBottomPoint[0]},${leftBottomPoint[1]}
                z`,
            });
          }
        });
      } else if (highlightBucket === bucket.text && side === 2) {
        otherBucket.forEach((oBucket, oIndex) => {
          if (
            oBucket.dots.some((s) =>
              bucket.dots
                .filter((f) => f.isHighlighted)
                .map((m) => m.key)
                .includes(s.key)
            )
          ) {
            const leftTopPoint = [
              this.props.width / 2 + (side === 1 ? 1 : -1) * barGapH + 5,
              topMargin -
                (_this.dotsRadius + 2) +
                oIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
                1,
            ];
            const leftBottomPoint = [leftTopPoint[0], leftTopPoint[1] + rectHeight - 2];
            const rightTopPoint = [
              this.props.width / 2 + (side === 1 ? -1 : 1) * barGapH - 5,
              topMargin -
                (_this.dotsRadius + 2) +
                bIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
                1,
            ];
            const rightBottomPoint = [rightTopPoint[0], rightTopPoint[1] + rectHeight - 2];
            this.pathData.push({
              d: `
                M${leftTopPoint[0]},${leftTopPoint[1]}
                C${leftTopPoint[0] + (rightTopPoint[0] - leftTopPoint[0]) / 2},${leftTopPoint[1]},${
                leftTopPoint[0] + (rightTopPoint[0] - leftTopPoint[0]) / 2
              },${rightTopPoint[1]},${rightTopPoint[0]},${rightTopPoint[1]}
                L${rightBottomPoint[0]},${rightBottomPoint[1]}
                C${rightBottomPoint[0] - (rightBottomPoint[0] - leftBottomPoint[0]) / 2},${
                rightBottomPoint[1]
              },${rightBottomPoint[0] - (rightBottomPoint[0] - leftBottomPoint[0]) / 2},${
                leftBottomPoint[1]
              },${leftBottomPoint[0]},${leftBottomPoint[1]}
                z`,
            });
          }
        });
      }
      bucket.dots.forEach((dot, dIndex) => {
        dot.cx =
          this.props.width / 2 +
          (side === 1 ? -1 : 1) *
            (barGapH + Math.ceil((dIndex + 1) / numDotsInRow) * _this.dotsRadius * 2);
        dot.cy =
          topMargin +
          bIndex * (numDotsInRow * _this.dotsRadius * 2 + barGap) +
          (dIndex % numDotsInRow) * _this.dotsRadius * 2;
        dot.r = this.dotsRadius;
        dot.color = this.state.dotColor;
      });
    });
  }

  singleVerticleLine() {
    const _this = this;
    const step = this.state.step;

    const { leftMargin, topMargin, labelWidth, numDotsInRow, barGap } =
      step.splitBar || _this.state.splitBar;

    let localData = this.dotsData.filter((f) => f.data && !f.discard);
    localData = localData
      .map((dot, dIndex) => {
        const sIndex = step.values.indexOf(dot.key);
        return { index: sIndex === -1 ? dIndex + step.values.length : sIndex, data: dot };
      })
      .sort((a, b) => a.index - b.index)
      .map((d) => d.data);

    localData.forEach((dot, dIndex) => {
      dot.cx = leftMargin / 2 + labelWidth + _this.dotsRadius * 2;
      dot.cy = topMargin + dIndex * barGap;
      dot.r = this.dotsRadius;
      dot.color = this.state.dotColor;
      this.labelData.push({
        class: "title-text-size buckets centered",
        text: `${dot.data[step.field]}`,
        dx: leftMargin,
        dy: topMargin + dIndex * barGap,
      });
    });
  }

  scatterPlot() {
    const _this = this;
    const step = this.state.step;
    const { leftMargin, topMargin, labelWidth, numDotsInRow, barGap } =
      step.splitBar || _this.state.splitBar;

    let localData = this.dotsData.filter((f) => f.data && !f.discard);

    let xAxisScale = null;
    if (step.xAxis.scale === "log") {
      xAxisScale = d3.scaleLog();
    } else {
      xAxisScale = d3.scaleLinear();
    }
    xAxisScale
      .domain(
        step.xAxis.domain
          ? step.xAxis.domain
          : d3.extent(localData.map((d) => +d.data[step.xAxis.field]))
      )
      .range([leftMargin, _this.props.width - 40])
      .clamp(step.xAxis.clamp != null ? step.xAxis.clamp : false);

    let yAxisScale = null;
    if (step.yAxis.scale === "log") {
      yAxisScale = d3.scaleLog();
    } else {
      yAxisScale = d3.scaleLinear();
    }
    yAxisScale
      .domain(
        step.yAxis.domain
          ? step.yAxis.domain
          : d3.extent(localData.map((d) => +d.data[step.yAxis.field]))
      )
      .range([this.svgHeight - 80, topMargin])
      .clamp(step.yAxis.clamp != null ? step.yAxis.clamp : false);

    localData.forEach((dot, dIndex) => {
      dot.cx = xAxisScale(+dot.data[step.xAxis.field]);
      dot.cy = yAxisScale(+dot.data[step.yAxis.field]);
      dot.r = this.dotsRadius;
      dot.color = this.state.dotColor;
    });

    this.rectData.push({ x: 80, y: yAxisScale(0.5), height: 0.2, width: _this.props.width - 40 });
    this.rectData.push({
      x: _this.props.width / 2,
      y: topMargin - 20,
      height: this.svgHeight - (topMargin + 40),
      width: 0.2,
    });

    this.labelData.push({
      class: "title-text-size buckets centered",
      text: "50%",
      dx: 100,
      dy: yAxisScale(0.5) - 10,
    });

    this.labelData.push({
      class: "title-text-size buckets centered",
      text: `Lower\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Monthly Target\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Higher`,
      dx: _this.props.width / 2,
      dy: this.svgHeight - 20,
    });
    this.labelData.push({
      class: "title-text-size buckets centered",
      text: `>50%\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Achievement\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0<50%`,
      dx: -(leftMargin + 60),
      dy: 40,
      transform: "rotate(-90)",
    });
  }

  scatterPlotPlanVsForecastError() {
    const _this = this;
    const step = this.state.step;
    const { labelWidth, numDotsInRow, barGap } = step.splitBar || _this.state.splitBar;
    const leftMargin = 150,
      topMargin = 50;
    const heightWidth =
      _this.props.width - leftMargin < this.svgHeight - 20 - topMargin
        ? _this.props.width - leftMargin
        : this.svgHeight - 20 - topMargin;
    let localData = this.dotsData.filter((f) => f.data && !f.discard);

    let xStart, xEnd, yStart, yEnd;
    xStart = leftMargin + (this.props.width - heightWidth) / 2;
    xEnd = xStart + heightWidth;
    yStart = topMargin;
    yEnd = yStart + heightWidth;

    let xAxisScale = d3.scaleLinear().domain([-102, 102]).range([xStart, xEnd]).clamp(true);

    let yAxisScale = d3.scaleLinear().domain([-102, 102]).range([yEnd, yStart]).clamp(true);

    localData.forEach((dot, dIndex) => {
      dot.cx = xAxisScale(+dot.data[step.xAxis.field]);
      dot.cy = yAxisScale(+dot.data[step.yAxis.field]);
      dot.r = this.dotsRadius;
      dot.color = this.state.dotColor;
    });

    // this.rectData.push({ x: xAxisScale(-102), y: yAxisScale(102), height: heightWidth, width: heightWidth })
    this.rectData.push({
      x: xAxisScale(-102) - this.dotsRadius * 2,
      y: yAxisScale(102) - this.dotsRadius * 2,
      height: heightWidth + this.dotsRadius * 4,
      width: heightWidth + this.dotsRadius * 4,
      class: "outlier",
    });
    this.rectData.push({
      x: xAxisScale(-100),
      y: yAxisScale(100),
      height: yAxisScale(-100) - yAxisScale(100),
      width: xAxisScale(100) - xAxisScale(-100),
      class: "bothError",
    });
    this.rectData.push({
      x: xAxisScale(-20),
      y: yAxisScale(100),
      height: yAxisScale(-100) - yAxisScale(100),
      width: xAxisScale(20) - xAxisScale(-20),
      class: "planGood",
    });
    this.rectData.push({
      x: xAxisScale(-100),
      y: yAxisScale(20),
      height: yAxisScale(-20) - yAxisScale(20),
      width: xAxisScale(100) - xAxisScale(-100),
      class: "forecastGood",
    });
    this.rectData.push({
      x: xAxisScale(-20),
      y: yAxisScale(20),
      height: yAxisScale(-20) - yAxisScale(20),
      width: xAxisScale(20) - xAxisScale(-20),
      class: "bothGood",
    });

    const data = [
      { text: "<20% error for both Plan and Forecast", class: "bothGood" },
      { text: "<20% error in only Forecast", class: "forecastGood" },
      { text: "<20% error in only Plan", class: "planGood" },
      { text: ">=20% error in both Plan and Forecast", class: "bothError" },
    ];
    data.forEach((d, i) => {
      this.rectData.push({ x: 50, y: topMargin + i * 50, height: 30, width: 30, class: d.class });
      this.labelData.push({
        class: "title-text-size buckets",
        text: d.text,
        dx: 90,
        dy: topMargin + 15 + i * 50,
      });
    });
  }

  listWithinCircularGroup() {
    const _this = this;
    const step = _this.state.step;

    this.rectData = [];
    this.labelData = [];
    this.pathData = [];

    let localData = _this.dotsData.filter((f) => f.data && !f.discard);

    /* Red = 1, Orange = 2, Green = 3 */
    localData.forEach((d) => {
      d.color = d.data.color === "1" ? "red" : d.data.color === "2" ? "orange" : "green";
    });

    const circularGroups = d3
      .nest()
      .key((k) => k.data[step.groupField])
      .key((k) => k.data[step.listField])
      .entries(localData)
      .sort((a, b) => {
        if (a.key > b.key) {
          return 1;
        } else {
          return -1;
        }
      });

    const topMargin = 40,
      bottomMargin = 50;
    const hSections = 3;
    const vGap = 50;
    const hGap = 35;
    let rowCounter = 1;
    const rectWidth = (_this.props.width - hGap * (hSections + 1)) / hSections;
    const rectHeight = (d3.max(circularGroups.map((d) => d.values.length)) + 1) * 20;
    let x = hGap;
    let y = topMargin + vGap;
    circularGroups.forEach((d, i) => {
      d.values = d.values.sort((a, b) => {
        if (a.key > b.key) {
          return 1;
        } else {
          return -1;
        }
      });
      _this.rectData.push({ x: x, y: y, height: rectHeight, width: rectWidth });
      _this.labelData.push({
        class: "title-text-size buckets centered highlight",
        text: d.key,
        dx: x + rectWidth / 2,
        dy: y - 10,
      });

      d.values.forEach((k, ki) => {
        _this.labelData.push({
          class: "body-text-size buckets",
          text: k.key,
          dx: x + 10,
          dy: y + ki * 20 + 20,
        });
        k.values = k.values.sort((a, b) => +a.data.type - +b.data.type);
        k.values.forEach((dot, dotIndex) => {
          dot.cx = x + rectWidth - (3 - dotIndex) * _this.dotsRadius * 3;
          dot.cy = y + ki * 20 + 20;
        });
      });

      if (i % hSections === hSections - 1) {
        x = hGap;
        y += rectHeight + vGap;
      } else {
        x += rectWidth + hGap;
      }
    });
    this.svgHeight =
      topMargin +
      bottomMargin +
      Math.ceil(circularGroups.length / hSections) * (rectHeight + vGap) +
      vGap;
    if (this.svgHeight < this.props.height - 40) {
      this.svgHeight = this.props.height - 40;
    }
  }

  zoomDot() {
    const _this = this;
    const step = this.state.step;

    const { leftMargin, topMargin, labelWidth, numDotsInRow, barGap } =
      step.splitBar || _this.state.splitBar;
    const availableWidth = this.props.width - (leftMargin + labelWidth + _this.dotsRadius * 4);
    const availableHeight = this.svgHeight - topMargin;
    const zoomRadius = 200;

    let localData = this.dotsData.filter((f) => f.data && !f.discard);
    localData = localData
      .map((dot, dIndex) => {
        const sIndex = step.values.indexOf(dot.key);
        return { index: sIndex === -1 ? dIndex + step.values.length : sIndex, data: dot };
      })
      .sort((a, b) => a.index - b.index)
      .map((d) => d.data);

    localData.forEach((dot, dIndex) => {
      dot.cx = leftMargin / 2 + labelWidth + _this.dotsRadius * 2;
      dot.cy = topMargin + dIndex * barGap;
      dot.r = dot.key === _this.state.focusValue ? this.dotsRadius * 2 : this.dotsRadius;
      dot.color = this.state.dotColor;
      let textString = dot.data[step.field];
      let length = 35;
      let subStringOfText =
        textString.length > length ? textString.substring(0, length - 3) + "..." : textString;
      this.labelData.push({
        class: "title-text-size buckets centered",
        text: subStringOfText,
        dx: leftMargin,
        dy: topMargin + dIndex * barGap,
      });
    });
  }

  placeRandomly() {
    this.dotsData.forEach((d) => {
      d.cx = this.dotsRadius * 2 + Math.random() * (this.props.width - this.dotsRadius * 4);
      d.cy = this.dotsRadius * 2 + Math.random() * (this.svgHeight - this.dotsRadius * 4);
      dot.r = this.dotsRadius;
      dot.color = this.state.dotColor;
    });
  }

  renderComponent() {
    this.svg.attr("height", this.props.height).attr("width", this.props.width);
    this.prepareData();
  }

  renderUpdates() {
    this.svg.attr("height", this.svgHeight).attr("width", this.svgWidth);

    const step = this.state.step;

    const { discardDelay, discardDuration, delay, duration } = this.state;
    const _this = this;

    let circles = _this.svg.select(".dotsContainer").selectAll(".dot").data(_this.dotsData);

    circles.exit().remove();

    const newItems = circles
      .enter()
      .append("circle")
      .attr("class", "dot")
      .classed("not-applicable", (d) => !d.data)
      .attr("cx", (d) => d.cx)
      .attr("cy", (d) => d.cy)
      .attr("r", (d) => 0)
      .style("stroke-width", "2px")
      .style("stroke", null)
      .style("fill", (d) => d.color || this.state.dotColor)
      .on("mouseenter", function (d) {
        if (!d.data) {
          return;
        }
        d3.select(this).style("stroke", "white");
        _this.tooltip.html(d.key);

        _this.tooltip.style("opacity", 1);

        _this.tooltip
          .style("left", d3.event.pageX - _this.tooltip.node().clientWidth / 2 + "px")
          .style(
            "top",
            d3.event.pageY - (_this.tooltip.node().clientHeight + _this.dotsRadius * 2) + "px"
          );
      })
      .on("mouseout", function (d) {
        d3.select(this).style("stroke", null);

        _this.tooltip.style("opacity", 0);
      })
      .on("click", function (d) {
        if (
          _this.state.step &&
          _this.state.step.operation === "focus" &&
          Array.isArray(_this.state.step.values)
        ) {
          _this.dispatchEvent("AxiomEventInfo", "changeFocusItem", { focusValue: d.key });
          return null;
        }
      });

    circles = circles.merge(newItems);

    const dataCircles = circles.filter((d) => {
      return d.data;
    });

    const filteredCircles = circles.filter((d) => {
      return d.discard == true && d.data;
    });
    const discardCircles = circles.filter((d) => {
      return d.discard == true && d.prevDiscard != true;
    });

    const filteredDotRadius = this.state.filteredDotRadius; // (0.0 * this.state.filteredDotRadius) + ((1 * this.state.filteredDotRadius) * (filteredCircles.size() / dataCircles.size()))
    const filteredCenterX = this.state.filteredDotRadius + 50;
    const filteredCenterY = this.svgHeight - (filteredDotRadius + 20);

    discardCircles
      .style("fill-opacity", 1)
      .transition()
      .delay((d, i) => (i * discardDelay) / discardCircles.size())
      .duration(discardDuration)
      .attr("cx", (d) => (d.data ? filteredCenterX : -100))
      .attr("cy", (d) => (d.data ? filteredCenterY : -100))
      .style("fill-opacity", 0);

    const availableCircles = circles.filter((d) => {
      return d.discard != true;
    });
    availableCircles
      .transition()
      .delay((d, i) =>
        discardCircles.size()
          ? discardDuration + discardDelay + (i * delay) / availableCircles.size()
          : (i * delay) / availableCircles.size()
      )
      .duration(duration)
      .attr("cx", (d) => d.cx)
      .attr("cy", (d) => d.cy)
      .attr("r", (d) => d.r - 0.25)
      // .style("fill", (d) => d.color || this.state.dotColor)
      .style("fill-opacity", (d) => {
        return d.data ? 1 : 0.4;
      })
      .style("fill", (d) => {
        return d.isHighlighted || !d.data ? d.color || this.state.dotColor : "#4AA4B8";
      });

    this.svg
      .select(".labelsContainer")
      .selectAll(".label")
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .remove();

    let labels = this.svg
      .select(".labelsContainer")
      .selectAll(".label-nothing")
      .data(_this.labelData);

    labels
      .exit()
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .remove();

    const newLabels = labels
      .enter()
      .append("text")
      .attr("x", function (d, i) {
        return d.dx;
      })
      .attr("y", function (d, i) {
        return d.dy;
      })
      .attr("transform", (d) => d.transform)
      .style("opacity", 0);

    labels = labels.merge(newLabels);

    labels
      .attr("class", (d) => `label ${d.class}`)
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .style("opacity", 1)
      .text(function (d) {
        return `${d.text}`;
      });

    let rects = this.svg.select(".rectsContainer").selectAll(".rect").data(_this.rectData);

    rects
      .exit()
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .remove();

    const newRects = rects.enter().append("rect").style("opacity", 0);

    rects = rects.merge(newRects);

    rects
      .attr("class", (d) => `rect ${d.class}`)
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .style("opacity", 1)
      .attr("x", function (d, i) {
        return d.x;
      })
      .attr("y", function (d, i) {
        return d.y;
      })
      .attr("width", function (d, i) {
        return d.width;
      })
      .attr("height", function (d, i) {
        return d.height;
      });

    let paths = this.svg.select(".pathsContainer").selectAll(".path").data(_this.pathData);

    paths
      .exit()
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .remove();

    const newPaths = paths.enter().append("path").style("opacity", 0);

    paths = paths.merge(newPaths);

    paths
      .attr("class", (d) => `path ${d.class}`)
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .style("opacity", 1)
      .attr("d", function (d, i) {
        return d.d;
      })
      .style("fill", (d) => d.fill || this.state.dotColor)
      .style("stroke", (d) => d.stroke || null);

    const { leftMargin, topMargin, labelWidth, numDotsInRow, barGap } =
      step.splitBar || _this.state.splitBar;

    if (this.svg.select(".labelsContainer").select(".title").size() === 0) {
      this.svg.select(".labelsContainer").append("text").attr("class", "title").style("opacity", 0);
    }
    if (step.statement) {
      let statement = step.statement;
      if (typeof statement === "string") {
        statement = [{ text: statement }];
      }
      this.svg
        .select(".labelsContainer")
        .select(".title")
        .transition()
        .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
        .duration(duration)
        .style("opacity", 1)
        // .text(this.state.step.statement)
        .attr("x", this.props.width / 2)
        .attr("y", topMargin - 60);
      this.svg.select(".labelsContainer").select(".title").selectAll("tspan").remove();
      this.svg
        .select(".labelsContainer")
        .select(".title")
        .selectAll("tspan")
        .data(statement)
        .enter()
        .append("tspan")
        .text((d) => d.text)
        .attr("class", (d) => d.class)
        .attr("dx", "5px");
    } else {
      this.svg.select(".labelsContainer").select(".title").remove();
    }

    this.svg
      .select(".legendsContainer .filteredDotsLabel")
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .attr("dx", filteredCenterX)
      .attr("dy", filteredCenterY + 30)
      .text(
        filteredCircles.size()
          ? `Filtered out: ${filteredCircles.size()}`
          : "Nothing is filtered out"
      );

    var data = [dataCircles.size() - filteredCircles.size(), filteredCircles.size()];
    var color = d3.scaleOrdinal().range(["rgb(216, 125, 103)", "rgba(74, 164, 184, 1)"]);

    var arc = d3.arc().outerRadius(this.state.filteredDotRadius).innerRadius(0);

    var pie = d3
      .pie()
      .value(function (d) {
        return d;
      })
      .sort(null);

    this.svg.select(".legendsContainer");
    const arcs = this.svg.select(".legendsContainer").selectAll(".arc").data(pie(data));

    function arcTween(d) {
      var i = d3.interpolate(this._current, d);

      this._current = i(0);

      return function (t) {
        return arc(i(t));
      };
    }

    arcs
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .attr("transform", "translate(" + filteredCenterX + "," + filteredCenterY + ")")
      .attrTween("d", arcTween)
      .style("fill", function (d) {
        return color(d.index);
      });

    d3.select(this.chartRef)
      .select(".child-element")
      .style("opacity", 0)
      .transition()
      .delay(discardCircles.size() ? discardDuration + discardDelay + delay : delay)
      .duration(duration)
      .style("opacity", 1);
  }

  zoomChart() {
    const _this = this;
    const step = { ...this.state.step };
    if (
      this.state.focusValue == null &&
      step.values &&
      Array.isArray(step.values) &&
      step.values[0] != null
    ) {
      this.dispatchEvent("AxiomEventInfo", "changeFocusItem", { focusValue: step.values[0] });
      return null;
    }

    const { leftMargin, topMargin, labelWidth } = step.splitBar || _this.state.splitBar;
    const availableWidth = this.props.width - (leftMargin + labelWidth + _this.dotsRadius * 4);
    const availableHeight = this.svgHeight - topMargin;

    const data = step.focusData.filter((f) => f[step.field] === this.state.focusValue);

    const pointInfo = _this.dotsData.filter((f) => f.key === this.state.focusValue)[0];

    return (
      <div
        className="child-element"
        style={{
          opacity: 0,
          marginLeft: leftMargin + labelWidth + _this.dotsRadius * 4,
          marginTop: -(availableHeight + topMargin),
          height: availableHeight,
          width: availableWidth,
          background: "rgba(255, 255, 0, 0)",
          position: "fixed",
        }}
      >
        {getChildComponent(
          this.state.step.type,
          availableHeight,
          availableWidth,
          data,
          this.props.appName,
          this.props.appID,
          step.field,
          this.state.focusValue,
          pointInfo,
          step.extraParams
        )}
      </div>
    );
  }

  focusSearch() {
    this.dispatchEvent("AxiomEventInfo", "setSearchBarFocus", {
      isSearchFocused: true,
    });
    this.searchRef.current.focus();
  }

  render() {
    return (
      <div
        ref={(ref) => (this.chartRef = ref)}
        className="InsightStory"
        style={{ height: this.props.height }}
      >
        {/*<div className={`insight-story-search ${this.state.isSearchFocused && "is-focused"}`}>
          <input
            ref={this.searchRef}
            className="insight-story-search-text title-text-size" />
          <svg
            onClick={(e) => this.focusSearch(e)}
            className="insight-story-search-icon" viewBox="0 0 32 32">
            <path d="M21.388 21.141c-0.045 0.035-0.089 0.073-0.132 0.116s-0.080 0.085-0.116 0.132c-1.677 1.617-3.959 2.611-6.473 2.611-2.577 0-4.909-1.043-6.6-2.733s-2.733-4.023-2.733-6.6 1.043-4.909 2.733-6.6 4.023-2.733 6.6-2.733 4.909 1.043 6.6 2.733 2.733 4.023 2.733 6.6c0 2.515-0.993 4.796-2.612 6.475zM28.943 27.057l-4.9-4.9c1.641-2.053 2.624-4.657 2.624-7.491 0-3.313-1.344-6.315-3.515-8.485s-5.172-3.515-8.485-3.515-6.315 1.344-8.485 3.515-3.515 5.172-3.515 8.485 1.344 6.315 3.515 8.485 5.172 3.515 8.485 3.515c2.833 0 5.437-0.983 7.491-2.624l4.9 4.9c0.521 0.521 1.365 0.521 1.885 0s0.521-1.365 0-1.885z"></path>
          </svg>
        </div>*/}
        <div className="tooltip" ref={(ref) => (this.tooltip = d3.select(ref))} />
        <svg
          ref={(ref) => {
            this.svg = d3.select(ref);
          }}
        >
          <g className="rectsContainer" />
          <g className="pathsContainer" />
          <g className="labelsContainer" />
          <g className="dotsContainer" />
          <g className="legendsContainer">
            <text className="filteredDotsLabel body-text-size" dx="0" dy="2000" />
            <path className="arc" transform="translate(0, 2000)" />
            <path className="arc" transform="translate(0, 2000)" />
            <rect className="filteredData" />
            <rect className="otherData" />
          </g>
        </svg>
        {this.state.step && this.state.step.operation === "focus" && this.zoomChart()}
      </div>
    );
  }
}
